<template>
  <div
    v-if="hasItems"
    class="panel-scrollbar flex min-h-0 flex-1 flex-col py-1"
    :class="menuClass"
    dusk="sidebar-menu"
    role="navigation"
    :data-screen="screen"
    :aria-label="__('Navigation')"
    :dir="isRTL ? 'rtl' : 'ltr'"
  >
    <component
      :key="item.key"
      :is="item.component"
      v-for="item in mainMenu"
      :item="item"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MainMenu',

  props: {
    /**
     * Rendering context for Dusk selectors and layout styles
     */
    screen: {
      type: String,
      default: 'responsive',
      validator: value => ['desktop', 'responsive'].includes(value),
    },
  },

  computed: {
    ...mapGetters(['mainMenu']),

    isRTL() {
      return Nova.config('rtlEnabled')
    },

    hasItems() {
      return this.mainMenu.length > 0
    },

    menuClass() {
      return this.screen === 'desktop'
        ? 'panel-sidebar-menu'
        : 'panel-mobile-menu'
    },
  },
}
</script>
